export default __webpack_public_path__ + "static/media/5.94e83d8b.jpg";